import React, { useState,useEffect } from 'react';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Banner from '../components/Banner';
import FilterSidebar from '../components/FilterSidebar';
import Deals from '../components/Deals';
import Footer from '../components/Footer';
import {fetchFilteredProducts}  from '../service/filterService';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  Checkbox,
  FormControlLabel,
  Slider,
  Divider,
  Box,
  Button,
  IconButton, 
   Collapse, 
  useMediaQuery,
  CircularProgress
} from '@mui/material';

import { useTranslation } from 'react-i18next';


const HomePage = () => {
  
  const DEFAULTPINCODE = "600017";
  const { user ,isUserLoading } = useAuth();
  

  const {
    pincode
  } = user || {};
  

  
  let effectivePincode;
  
    const isUserValid = user && Object.keys(user).length > 0;
     if (isUserValid && user.pincode && user.pincode.trim() !== "") {
    effectivePincode = user.pincode;
} else {
    effectivePincode = DEFAULTPINCODE;
}
  

  
 
  
  const { t } = useTranslation();
   const [filters, setFilters] = useState(null);
 //     const [filters, setFilters] = useState({ brands: [], priceRange: [0, 5000], searchTxt: "" , customerPincode: effectivePincode, inventoryStatus: ["AVAILABLE", "BACKORDERED"]});
  const [filteredProducts, setFilteredProducts] = useState([]);
  const isMobile = useMediaQuery('(max-width:768px)');
    const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
 const navigate = useNavigate(); 

  
  const handleSelectCategory = (category, subCategory) => {
    
    setSelectedCategory(category);
    setSelectedSubCategory(subCategory);
    
     setPage(0); 
    
  setFilters({ brands: [], priceRange: [0, 5000], searchTxt: "", subCategories: [subCategory], categories: [category] , customerPincode: effectivePincode, inventoryStatus: ["AVAILABLE", "BACKORDERED"]});
/*  setFilters((prevFilters) => ({
        ...prevFilters,
        subCategories: [subCategory],
        categories: [category],
      })); */

  };
  
  const handleOnSearch = (searchQuery) => {
    
     setPage(0);
    setFilters({brands: [], priceRange: [0, 5000], 
        searchTxt: searchQuery, customerPincode: pincode, inventoryStatus: ["AVAILABLE", "BACKORDERED"]
      });
  };
    
  
const [sidebarOpen, setSidebarOpen] = useState(false);
const toggleSidebar = () => {
  setSidebarOpen(prev => !prev);
};
  

    const [page, setPage] = useState(0);
const [pageSize, setPageSize] = useState(12);
const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);


// Function Signature (Recommended to accept all necessary state as arguments)
async function fetchFilteredAllProducts(currentPage, currentSize, currentFilters) {
    if (isLoading) return;
    setIsLoading(true);
    
    try {
        // Pass the currentFilters object to your API service
        const res = await fetchFilteredProducts(currentFilters, currentPage, currentSize); 
        
        const newProducts = res.data.content;
        const newTotal = res.data.totalElements;

        setFilteredProducts(prevProducts => {
            // Check if we are loading the first page (page 0), meaning REPLACE
            if (currentPage === 0) {
                return newProducts; 
            } else {
                return [...prevProducts, ...newProducts]; // Otherwise, APPEND
            }
        });
        setTotal(newTotal);

    } catch (error) {
        // ...
    } finally {
        setIsLoading(false);
    }
}
  
  useEffect(() => {
    if (user && user.emailVerified === false) {
            // Navigate the user to the login screen
            console.log("User verification is false, navigating to /login");
            navigate('/login');
  }
 }, [user, navigate]);

useEffect(() => {
    if (!isUserLoading) {
      const effectivePincode = (user && user.pincode && user.pincode.trim() !== "") ? user.pincode 
                                : DEFAULTPINCODE;
      
      setFilters({
        customerPincode: effectivePincode,
         brands: [], priceRange: [0, 5000], searchTxt: "" , inventoryStatus: ["AVAILABLE", "BACKORDERED"]
      });
    }
  }, [isUserLoading, user]);

  // --- EFFECT 2: Reset Page on Filter Change ---
  useEffect(() => {
    if (filters) {
      setPage(0);
    }
  }, [filters]);

  // --- EFFECT 3: Main Data Fetching ---
  useEffect(() => {
    // 🛑 GATEKEEPER: Don't fetch if user is loading OR filters aren't ready
    if (isUserLoading || !filters) return;

    const loadData = async () => {
       try {
         console.log(`Fetching page ${page} with pincode: ${filters.customerPincode}`);
         fetchFilteredAllProducts(page, pageSize, filters);
       } catch (err) {
         console.error("Fetch Error:", err);
       }
    };

    loadData();
  }, [page, pageSize, filters, isUserLoading]);

  // --- RENDER LOGIC ---
  
  // Show spinner while checking Auth OR waiting for filters to initialize
  if (isUserLoading || !filters) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }


return (
    <>
      <Header onSearch={handleOnSearch} />
      
     <Menu onSelectCategory={handleSelectCategory} />

      <Box display="flex" sx={{ 
      maxWidth: '100%', 
      overflowX: 'hidden', // Prevents the "Deals" section from pushing the page wide
      minHeight: '100vh' 
    }}>
      {/* Sidebar with toggle arrow */}

{!isMobile && (
  <>
    {/* 1. Renders the open sidebar with its close button */}
    <Collapse in={sidebarOpen} orientation="horizontal">
      <Box
        sx={{
          width: 150,
          borderRight: "1px solid #ddd",
          position: "relative",
          backgroundColor: "#fafafa",
          height: "100vh",
          fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.775rem' },
        }}
      >
        <FilterSidebar
          filters={filters}
          setFilters={setFilters}
          onApplyFilters={fetchFilteredAllProducts}
        />
        <IconButton
          onClick={toggleSidebar}
          sx={{
            position: "absolute",
            top: "50%",
            right: -20,
            transform: "translateY(-50%)",
            backgroundColor: "white",
            border: "1px solid #ccc",
            "&:hover": { backgroundColor: "#f0f0f0" },
          }}
          size="small"
        >
          <ChevronLeftIcon />
        </IconButton>
      </Box>
    </Collapse>

    {/* 2. Renders the open button when the sidebar is NOT open */}
    {!sidebarOpen && (
      <IconButton
        onClick={toggleSidebar}
        sx={{
          position: "relative",
          backgroundColor: "white",
          border: "1px solid #ccc",
          height: "40px",
          marginTop: "20px",
          "&:hover": { backgroundColor: "#f0f0f0" },
        }}
        size="small"
      >
        <ChevronRightIcon />
      </IconButton>
    )}
  </>
)}

        {/* Main Content */}
 <Box component="main" sx={{ 
        flexGrow: 1, 
        p: { xs: 1, sm: 2, md: 3 }, // Reduced padding on mobile
        width: '100%',
        overflowX: 'hidden', // Extra safety for the grid negative margin
        boxSizing: 'border-box'
      }}>
     
      {/* <Deals
            selectedCategory={selectedCategory}
            selectedSubCategory={selectedSubCategory}
            filters={filters}
          /> */}
    
         <Deals products={filteredProducts} />
 
        <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', // 🔥 Changed from 'flex-end' to 'center'
              mt: 4 // Increased Margin Top for spacing
            }}
          >
<Button
  onClick={() => setPage(prevPage => prevPage + 1)}
  disabled={isLoading || filteredProducts.length >= total}
sx={{ 
    fontWeight: 'bold', 
    fontSize: { 
      xs: '0.9rem', // Mobile
      sm: '1.2rem', // Tablet
      md: '1.5rem'  // Desktop
    } 
  }}
>
  {/* 🔥 Updated using the t() function with English strings as fallbacks */}
  {isLoading 
    ? t('loading', 'Loading...') // Looks for the key 'loading', defaults to 'Loading...'
    : t('load_more', 'Load More') // Looks for the key 'load_more', defaults to 'Load More'
  }
</Button>
          </Box>

          <Banner />
        </Box>
      </Box>
   <Footer />
    </>
  );
};

export default HomePage;
